module.exports = __webpack_public_path__ + "img/Z86_06.a15a562c.jpg";